<button mat-icon-button class="close-button" (click)="onDismiss()">
  <mat-icon class="close-icon" >close</mat-icon>
</button>
<h1 mat-dialog-title>{{finalizeClaimModal.header}}</h1>
<div mat-dialog-content>{{finalizeClaimModal.body}}</div>
<div mat-dialog-actions>
  <button mat-button (click)="onDismiss()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Finalize</button>
</div>
